import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OrdersWaysFormView } from './orders-ways-form-view';
import { validate } from '../../utils';
import { FORM_NAME } from '../../constants';
import { getFormInitialValuesSelector, getIsOptionsListLoadingSelector, getOptionsListSelector } from '../../selectors';

const OrdersWaysFormWrapper = ({ optionsList, isOptionsListLoading }) => {
	return <OrdersWaysFormView optionsList={optionsList} isOptionsListLoading={isOptionsListLoading} />;
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
	keepDirtyOnReinitialize: true,
})(OrdersWaysFormWrapper);

const mapStateToProps = createStructuredSelector({
	optionsList: getOptionsListSelector(),
	isOptionsListLoading: getIsOptionsListLoadingSelector(),
	initialValues: getFormInitialValuesSelector(),
});

const OrdersWaysForm = connect(mapStateToProps)(withForm);

OrdersWaysFormWrapper.propTypes = {
	optionsList: PropTypes.objectOf(
		PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string.isRequired,
				value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
				key: PropTypes.string.isRequired,
			}),
		),
	),
	isOptionsListLoading: PropTypes.objectOf(PropTypes.bool.isRequired).isRequired,
};

export { OrdersWaysForm };
